export default '/pricing/data-removal';
